<template>
  <div style="position: relative;height: 100%">
    <div class="icon-map" @click="addOrRemove">
      <div style="padding-top: 8px"><img v-if="isAdd" src="../../../assets/icon/map_blue.png"><img v-else src="../../../assets/icon/map_gray.png"> </div>
      <div style="margin-top: 6px"><span v-if="isAdd" style="color: #1eb2ff">卫星</span><span v-else style="color: #8e8e8e">卫星</span></div>
    </div>
    <div style="height: 100%;width: 100%">
      <iframe id="mainIframe" ref="mainIframe" name="mainIframe" style="width: 100%;height: 100%;margin: auto"
              src="./static/Amap.html" frameborder="0" scrolling="no">
      </iframe>
    </div>
  </div>
</template>

<script>

export default {
  name: 'electronicMap',
  props: {
    electronicObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isAdd: false,
      electronicRow: ''
    }
  },
  created () {
    this.golobleObject.initMapCompleted = this.initMapCompleted
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    initMapCompleted () {
      this.getPolygonCircle()
    },
    addOrRemove () {
      this.isAdd = !this.isAdd
      if (!this.isAdd) {
        window.frames['mainIframe'].window.removeLayer()
      } else {
        window.frames['mainIframe'].window.addLayer()
      }
    },
    getStartData (obj) {
      // console.log(111)
      this.electronicRow = obj
      this.getPolygonCircle()
    },
    getPolygonCircle () {
      window.frames['mainIframe'].window.removePolygonCircle()
      if (this.electronicRow === '') {
        return
      }
      this.circle_type = this.electronicRow.circle_type
      if (this.electronicRow.circle_area === '') {
        return
      }
      let area = ''
      area = JSON.parse(this.electronicRow.circle_area)
      if (this.electronicRow.circle_type === 1) {
        this.getCircle(area)
      } else if (this.electronicRow.circle_type === 2) {
        this.getPolygon(area)
      }
      // console.log(99, area)
    },
    getCircle (area) {
      // console.log(area)
      if (area.point.x === 0 && area.point.y === 0) {
        return
      }
      window.frames['mainIframe'].window.showCircle(area.point.y, area.point.x, area.radius)
    },
    getPolygon (area) {
      // console.log('area', area)
      // let path = [[116.475334, 39.997534], [116.476627, 39.998315], [116.478603, 39.99879], [116.478529, 40.000296], [116.475082, 40.000151], [116.473421, 39.998717]]
      let path = []
      if (area['point1']) {
        path.push([area['point1'].y, area['point1'].x])
      }
      if (area['point2']) {
        path.push([area['point2'].y, area['point2'].x])
      }
      if (area['point3']) {
        path.push([area['point3'].y, area['point3'].x])
      }
      if (area['point4']) {
        path.push([area['point4'].y, area['point4'].x])
      }
      if (area['point5']) {
        path.push([area['point5'].y, area['point5'].x])
      }
      if (area['point6']) {
        path.push([area['point6'].y, area['point6'].x])
      }
      if (area['point7']) {
        path.push([area['point7'].y, area['point7'].x])
      }
      if (area['point8']) {
        path.push([area['point8'].y, area['point8'].x])
      }
      window.frames['mainIframe'].window.showPolygon(path)
    }
  }
}
</script>

<style scoped>
.icon-map {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 40px;
  height: 80px;
  background-color: #FFFFFF;
  box-shadow: 0 0 10px 0 #999999;
  border-radius: 4px;
  z-index: 999;
  cursor: pointer;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/electronicMap.vue